
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqPZLQdrVX9APhm9ofE6kewEW7t_XYcFuOJEJReVbvRZUMeta } from "/codebuild/output/src87685858/src/src/pages/faq.vue?macro=true";
import { default as menu2fTidOwV62J7tG6WRY8tphuqypjLDRqA_9XV54frhXwMeta } from "/codebuild/output/src87685858/src/src/pages/menu.vue?macro=true";
import { default as index_45pYxdot9BZb8dQgfeJ5oiP3OLJKXdBNedxdiG_3rIrsMeta } from "/codebuild/output/src87685858/src/src/pages/index.vue?macro=true";
import { default as contactTM576nbLJ9N_45mIIZWp_45zQEFMEYZ5UOQH7YhpjNFd_45SUMeta } from "/codebuild/output/src87685858/src/src/pages/contact.vue?macro=true";
import { default as tutorialItBac8Xv1xnK_45V1CuuV_0clVIF1Mi_45ziV22wjOAwvkwMeta } from "/codebuild/output/src87685858/src/src/pages/tutorial.vue?macro=true";
import { default as agreementsldE90VXvyLD63pjRQF0vNSmvB5OPemffDK4D1b72ScMeta } from "/codebuild/output/src87685858/src/src/pages/agreement.vue?macro=true";
import { default as about_45passlEZSy0_45FuY058JtDOpuUC3YVbEBqIgJnYTiMUwOBgpkMeta } from "/codebuild/output/src87685858/src/src/pages/about-pass.vue?macro=true";
import { default as index5LK6jKhbz_KAtnZkx0MSysCnIhaz_qLFDRoIOcgWjAsMeta } from "/codebuild/output/src87685858/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93FrvacrzjVAqx9mpbTc2WiBLY9TgL6zqmODf6wgES3KUMeta } from "/codebuild/output/src87685858/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancegCwDQMxCRdfkz3B8biVJJAuRUONjkLcM3m9_45cnIduHsMeta } from "/codebuild/output/src87685858/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93UmR97qJsVl2P6Ku3zV1VttuVd_7LT_MeYl_458Wn_seusMeta } from "/codebuild/output/src87685858/src/src/pages/notice/[id].vue?macro=true";
import { default as indext0TOJyi78TqHjLQZbMAd_455wQKuTvjGprdIg27ic_PWEMeta } from "/codebuild/output/src87685858/src/src/pages/coupon/index.vue?macro=true";
import { default as indexr6M6KepXZqD87vgrf7sFojco4Vyn8sV7ibesBddncSkMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/index.vue?macro=true";
import { default as indexxjvxrNYJyJHnEpKw2o4lq0gLd5CsUOe_9KIdomeaWuQMeta } from "/codebuild/output/src87685858/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_9317KvMD19E21LmoBlZ3A26FDnb01OHWt1fUC9pYAY9EkMeta } from "/codebuild/output/src87685858/src/src/pages/parking/[id].vue?macro=true";
import { default as indexaxhRxGMW6ASIn49Can9Xnp88gPYUoU1pbSjEuLIoqagMeta } from "/codebuild/output/src87685858/src/src/pages/history/index.vue?macro=true";
import { default as indexq8X3A9z7TxQ3V36Qjq5W_E4CtMEWa9cIXYtOAOANVlkMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/index.vue?macro=true";
import { default as indexMLfrEkVLRhA9aKLcoSOKPxPRDhIiqEy1KEBG8J6_RfEMeta } from "/codebuild/output/src87685858/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexcYOCKMtD4UoJxGDpi8Z09h5S_4518WGBfqP3pKPltXiGoMeta } from "/codebuild/output/src87685858/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi8ESCPmKOxv6dfS0HIPi2qBNLwFb26_gzi8_45RH35fB_45IMeta } from "/codebuild/output/src87685858/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editC0Fef5v6IxOoNDy5isLaqZB_GquyYexZdFWbJBMqVXYMeta } from "/codebuild/output/src87685858/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementRzQbajIG_45Eg68BEkGsZjvIvaqTg8H6Ok26akHgl_xWkMeta } from "/codebuild/output/src87685858/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexNRSxvZUbRJNgO0ci_1k7LRFNERtBfZuqM0SUeAaGFacMeta } from "/codebuild/output/src87685858/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d8XkmDFTcvOwT4vX7zmMLiwrL9D943KmcPpWUjAlektsMeta } from "/codebuild/output/src87685858/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmSb7FlCB5KhmLOBSmrTUMcziOR8hlXTQpLUgVCN_45wpOsMeta } from "/codebuild/output/src87685858/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexVg5HriB2mlnYw5zuEZqwG3ZC5jkSi5jA57waZFXJissMeta } from "/codebuild/output/src87685858/src/src/pages/card/create/index.vue?macro=true";
import { default as indexaptM4UXSOPKexn21xMbzj5zdHCigcmYaUNtoKmbvpFUMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmUo8SSJjx1PWGu_45D_bYxE6dQU9Fw463qYchC2DxX6s9YMeta } from "/codebuild/output/src87685858/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmWkY4qz6GIusSKEWBnBpw73vYe3kN6drFUqcO4lV8IagMeta } from "/codebuild/output/src87685858/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeYamdcjkG2irmu7T_2drjuQmK0pe13RxEnqf84rcvRkMMeta } from "/codebuild/output/src87685858/src/src/pages/membership/complete.vue?macro=true";
import { default as registerBgiU1LY2z4pU5CZjq2ZFvwL_45VTSnR42l6rd7vWZZ8OgMeta } from "/codebuild/output/src87685858/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93Fsef9y_45bwtaV9CUUtewZO16v_9RimWd_K8IQEYfVSSMMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm8O4g6Uh1W5UxOAhngi20uUvKNRIlfXF09ZOAAOG_uD4Meta } from "/codebuild/output/src87685858/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93aPi6zAbPj6XPjTT13HztqzMfcTv38SpY_45od7cq4IF_YMeta } from "/codebuild/output/src87685858/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexsZgWCTxnbvVp65q_45C_458aJNAOAfcOqmlhB74ev2b8L7sMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code6O_exnTFQCJg185_45UozYwpNCSBYNnphM93DoVHzuejUMeta } from "/codebuild/output/src87685858/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeej0xOxfbD2rsfKNdgp8X8VBgf7_45sTRKKM91z2EMATuoMeta } from "/codebuild/output/src87685858/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete6H3e_XtKUhvZeGk_CPqGAFN0Dv98rgYwp0gDyJ18LVAMeta } from "/codebuild/output/src87685858/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerRMZ4l3RJIwdVONqMeJASMXL0MKxVDWnDjUBVgxMuRcoMeta } from "/codebuild/output/src87685858/src/src/pages/contact-form/register.vue?macro=true";
import { default as completex4otlPSdPoeI1f3agx8RBf9UPWf1q_450tzxm1ml8Z3_450Meta } from "/codebuild/output/src87685858/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexbMR5a0DeCX4mklsZmv7YYp9P05ZJdADB6hm1Ob9ntkMMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmnaHf2CVyBFPb3p_45yuy_HQDBIZkI7o4IXVH1DjmS2JY4Meta } from "/codebuild/output/src87685858/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeAwR4oZDcauzNtHxpEjRJh1PMIFzxAMKiaQUNsaSm6lQMeta } from "/codebuild/output/src87685858/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexXXh8lm_99JqVT3zkvYhjtordmyii5VLk_45phbKPNqIw8Meta } from "/codebuild/output/src87685858/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93aNjSnmgZQF3VF3_47p9GEI_a1rpCXr5WUhi_45nAFY6zoMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeobUdbIn6QGaAsKNezoxTd_36WvmyfWAEZPNEHPWT9cYMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasecgXWAAYwis_45mJX_45Tay0S3XWoDqfXSt_45yIsfS0foDOwMeta } from "/codebuild/output/src87685858/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplei9avK2RJnQsX5QSfsmqtNoKQ6xu_hHhtjaoqJF4_451tMMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailVtnqu9Qzge2jMg3kZgqy2vNhmq_PbcByEe43CCk5mjUMeta } from "/codebuild/output/src87685858/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmm052LJ5VxmJMkb_45zWxvL5i_45Qrq4eluZSHAv8ZQxFvfAMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentIar4vrE16t00nIGUY1d3Ql2imFeZgYBpUkrV7JY0MMsMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmr5CZEAA2s2D_450pVoEyycRGEBRqqqRG3SNBn6XZb7qlYMeta } from "/codebuild/output/src87685858/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateS6fMXz4bfGVvXEqASiUyYwMRfe_452kBnTWpKZlLI8Z9IMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeXnsJJ0ubGYT1a5tEW8GyFp5g_45A_dXHmjK7LSGfIdCiQMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codez46tyFHzVgQz6Qb8mfHRmrPFxaIIgEQdknAB9t6eJ1AMeta } from "/codebuild/output/src87685858/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordpZdzkA5EpQKrZugQH_45JvIgC6hkhhzqKAtw7fBnFSiTwMeta } from "/codebuild/output/src87685858/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaskBedFXFhHZ5IFDWHtTKYxYZiBFze49TaZ_45MbYtolS7IMeta } from "/codebuild/output/src87685858/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register7deukL_45OVpxXR6a83vmJ5RL7rLQuRxAAjMeTbP5j9yMMeta } from "/codebuild/output/src87685858/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codemPAHl_45XAdaG2neKGiB5UyGHQ6uArKo_45k5yEnv3Q4_q4Meta } from "/codebuild/output/src87685858/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexb0vK_45n_ACf6JvMM6lWEvNYi4wE_45kzU1Q45XCccmSCCAMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexmzHo7EJHWsfHItjWWz147SrrsDLe_45Cw0xobUZSFJdcQMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexpneyONjNyQK3V11Y8cxDtTd5afZMbhGJs3qlRETGkUsMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index9vbROOmvv2IZ2BR1DXMvGkHllg8HgfB4dUFPj8BCSNkMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update1lHBNJ_H_45LGPocs_UwljkIm1RzSEgOACeVAuwKwtSTwMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completehRJK9nfkmnZxS276KEg_45BF4geAG06JEL8cIEwzyDg4YMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm0ewkXvLstI18SqaGF2ZmcwC492dqPq_zsXe_45LyWEBYMMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexkSMTJj4zOQVNjEgD3ThKmUVm_BltqolHu6oCq0cVVloMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completepouCuaDZ2Q_45Sgj9PVf06uPorRe3iI6K08M_455_45qp4oWoMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update4sw7dnjWee_455s_45ut9v_45_45tdqbIvqQyCl89HgaL_hqPcwMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexXZ50fHibVhS9If01530lukqf_nxKG_45USa7D7oNMpHFkMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexaXJjVnuXpdMTslel4H_45AbEFrq_1repOx7mw8RlBi3swMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeAw4VhXbPiaecH0ybXdjBtQla8Ok3DyuNRpwSC5WWU30Meta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index5aK8dTUbxrIOn0UEbx1pA69nsJZg93m9X2mgyqAk8T4Meta } from "/codebuild/output/src87685858/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeTXk_1jTseC3y4aRo1WNC_cybwaQln2pRXj1b4rG2cUsMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index4_45eT6IWKpQQIQxXIH4MKDlFkL8Sous1vwaj_rn_uTzsMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexvfEveiDIwCSu66a3mXh8L5LrE_452_7ta6QjUKQUWDr5AMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index_45BNH2o9x64zAUKXt2_4574DWjTMNn62_vWj_45VKY7myGroMeta } from "/codebuild/output/src87685858/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateZq15W1za_TkHPb9jq_pCcHxKJ68jHEn6h3o8NyQ2_mkMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm1n52CoPi5lKwn_Ik630Jjnqz1d7IshOAAC9FuCD8r4gMeta } from "/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src87685858/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu2fTidOwV62J7tG6WRY8tphuqypjLDRqA_9XV54frhXwMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index_45pYxdot9BZb8dQgfeJ5oiP3OLJKXdBNedxdiG_3rIrsMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src87685858/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src87685858/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src87685858/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src87685858/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src87685858/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indext0TOJyi78TqHjLQZbMAd_455wQKuTvjGprdIg27ic_PWEMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src87685858/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src87685858/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexaxhRxGMW6ASIn49Can9Xnp88gPYUoU1pbSjEuLIoqagMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexMLfrEkVLRhA9aKLcoSOKPxPRDhIiqEy1KEBG8J6_RfEMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexcYOCKMtD4UoJxGDpi8Z09h5S_4518WGBfqP3pKPltXiGoMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src87685858/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src87685858/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexVg5HriB2mlnYw5zuEZqwG3ZC5jkSi5jA57waZFXJissMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmUo8SSJjx1PWGu_45D_bYxE6dQU9Fw463qYchC2DxX6s9YMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmWkY4qz6GIusSKEWBnBpw73vYe3kN6drFUqcO4lV8IagMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeYamdcjkG2irmu7T_2drjuQmK0pe13RxEnqf84rcvRkMMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerBgiU1LY2z4pU5CZjq2ZFvwL_45VTSnR42l6rd7vWZZ8OgMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm8O4g6Uh1W5UxOAhngi20uUvKNRIlfXF09ZOAAOG_uD4Meta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code6O_exnTFQCJg185_45UozYwpNCSBYNnphM93DoVHzuejUMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeej0xOxfbD2rsfKNdgp8X8VBgf7_45sTRKKM91z2EMATuoMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete6H3e_XtKUhvZeGk_CPqGAFN0Dv98rgYwp0gDyJ18LVAMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerRMZ4l3RJIwdVONqMeJASMXL0MKxVDWnDjUBVgxMuRcoMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmnaHf2CVyBFPb3p_45yuy_HQDBIZkI7o4IXVH1DjmS2JY4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeAwR4oZDcauzNtHxpEjRJh1PMIFzxAMKiaQUNsaSm6lQMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexXXh8lm_99JqVT3zkvYhjtordmyii5VLk_45phbKPNqIw8Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeobUdbIn6QGaAsKNezoxTd_36WvmyfWAEZPNEHPWT9cYMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplei9avK2RJnQsX5QSfsmqtNoKQ6xu_hHhtjaoqJF4_451tMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailVtnqu9Qzge2jMg3kZgqy2vNhmq_PbcByEe43CCk5mjUMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmm052LJ5VxmJMkb_45zWxvL5i_45Qrq4eluZSHAv8ZQxFvfAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentIar4vrE16t00nIGUY1d3Ql2imFeZgYBpUkrV7JY0MMsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmr5CZEAA2s2D_450pVoEyycRGEBRqqqRG3SNBn6XZb7qlYMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeXnsJJ0ubGYT1a5tEW8GyFp5g_45A_dXHmjK7LSGfIdCiQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codez46tyFHzVgQz6Qb8mfHRmrPFxaIIgEQdknAB9t6eJ1AMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordpZdzkA5EpQKrZugQH_45JvIgC6hkhhzqKAtw7fBnFSiTwMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src87685858/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register7deukL_45OVpxXR6a83vmJ5RL7rLQuRxAAjMeTbP5j9yMMeta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codemPAHl_45XAdaG2neKGiB5UyGHQ6uArKo_45k5yEnv3Q4_q4Meta || {},
    component: () => import("/codebuild/output/src87685858/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src87685858/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src87685858/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]